angular
    .module("skillBuilderSaaS")
    .directive("hires", function () {
    return {
        restrict: "A",
        scope: { hires: "@" },
        link: function (scope, element, attrs) {
            var initialLoad = false;
            element.bind("load", function () {
                initialLoad = true;
                if (!scope.hires)
                    return;
                element.attr("src", scope.hires);
                element.unbind("load");
            });
            attrs.$observe("hires", function (value) {
                if (!value)
                    return;
                if (initialLoad)
                    element.attr("src", value);
            });
        }
    };
});
